import { SettingApi } from "lib/api";
import { ApiHelper, Http } from "lib/api/base";

import { Section, SectionVersion } from "lib/data/model";
import { ValidationError } from "lib/data/transfer/ValidationError";
import { SerializableError } from "lib/data/types";

export class SectionVersionApi {

	public static getSectionVersion = async (section: Section, id: number): Promise<SectionVersion | undefined> => {

		// Get Base Url
		const baseUrl = SettingApi.getApiBaseUrl();

		// Check Base Url
		if (baseUrl) {

			// Configure Url
			const url: string = `${baseUrl}/Section/${section.id}/Version/${id}`;

			// Check For Requested State

			// Make Request
			const response: Response = await Http.httpGet(url, undefined);

			// Check Response
			if (response.ok) {

				// Parse Response Body
				const sectionVersion: SectionVersion = await ApiHelper.parseResponseBody(response);

				return sectionVersion;
			}

			// TODO: Handle Errors
		}

		// Return Nothing
		return undefined;
	}

	public static getPublished = async (section: Section): Promise<SectionVersion | undefined> => {

		// Get Base Url
		const baseUrl = SettingApi.getApiBaseUrl();

		// Check Base Url
		if (baseUrl) {

			// Configure Url
			const url: string = `${baseUrl}/Section/${section.id}/Publish`;

			// Initialize Response
			const response: Response = await Http.httpGet(url, undefined);

			// Check Response
			if (response.ok) {

				// Parse Response Body
				const saved: SectionVersion = await ApiHelper.parseResponseBody(response);

				return saved;
			}
		}

		// Return Nothing
		return undefined;
	}

	public static getPublishedById = async (sectionId: number): Promise<SectionVersion | undefined> => {

		// Get Base Url
		const baseUrl = SettingApi.getApiBaseUrl();

		// Check Base Url
		if (baseUrl) {

			// Configure Url
			const url: string = `${baseUrl}/Section/${sectionId}/Publish`;

			// Initialize Response
			const response: Response = await Http.httpGet(url, undefined);

			// Check Response
			if (response.ok) {

				// Parse Response Body
				const saved: SectionVersion = await ApiHelper.parseResponseBody(response);

				return saved;
			}

			// TODO: Handle Errors
		}

		// Return Nothing
		return undefined;
	}

	public static getDraft = async (section: Section): Promise<SectionVersion | undefined> => {

		// Get Base Url
		const baseUrl = SettingApi.getApiBaseUrl();

		// Check Base Url
		if (baseUrl) {

			// Configure Url
			const url: string = `${baseUrl}/Section/${section.id}/Draft`;

			// Initialize Response
			const response: Response = await Http.httpGet(url, undefined);

			// Check Response
			if (response.ok) {

				// Parse Response Body
				const saved: SectionVersion = await ApiHelper.parseResponseBody(response);

				return saved;
			}

			// TODO: Handle Errors
		}

		// Return Nothing
		return undefined;
	}

	public static getDraftById = async (sectionId: number): Promise<SectionVersion | undefined> => {

		// Get Base Url
		const baseUrl = SettingApi.getApiBaseUrl();

		// Check Base Url
		if (baseUrl) {

			// Configure Url
			const url: string = `${baseUrl}/Section/${sectionId}/Draft`;

			// Initialize Response
			const response: Response = await Http.httpGet(url, undefined);

			// Check Response
			if (response.ok) {

				// Parse Response Body
				const saved: SectionVersion = await ApiHelper.parseResponseBody(response);

				return saved;
			}

			// TODO: Handle Errors
		}

		// Return Nothing
		return undefined;
	}

	public static updateDraft = async (parentSection: Section, sectionVersion: SectionVersion): Promise<SectionVersion | undefined> => {

		// Get Base Url
		const baseUrl = SettingApi.getApiBaseUrl();

		// Check Base Url
		if (baseUrl) {

			// Configure Url
			const url: string = `${baseUrl}/Section/${parentSection.id}/Draft/${sectionVersion.id}`;

			// Initialize Response
			const response: Response = await Http.httpPut(url, sectionVersion);

			// Check Response
			if (response.ok) {

				// Parse Response Body
				const saved: SectionVersion = await ApiHelper.parseResponseBody(response);

				return saved;
			}
			else {

				// Get Response Body
				const responseBody = await ApiHelper.parseResponseBody(response);

				// Initialize Error Message
				let errorMessage: string = "There was an error while updating the draft";

				// Check Response Body
				if (responseBody !== undefined && responseBody !== null && typeof responseBody === "string") {

					// Overwrite Error Message
					errorMessage = responseBody;
				}

				// Inform User
				notification.success({
					message: "Save Failed",
					description: errorMessage
				});
			}
		}

		// Return Nothing
		return undefined;
	}

	public static validateDraft = async (section: Section): Promise<true | ValidationError | undefined> => {

		// Get Base Url
		const baseUrl = SettingApi.getApiBaseUrl();

		// Check Base Url
		if (baseUrl) {

			// Configure Url
			const url: string = `${baseUrl}/Section/${section.id}/Draft/Validate`;

			// Initialize Response
			const response: Response = await Http.httpGet(url, undefined);

			// Check Response
			if (response.ok) {

				// Return Is Validated
				return true;
			}
			else {

				// Switch On Status Code
				switch (response.status) {

					case 422: // Unprocessable Entity

						// Get Errors
						const errors: SerializableError = await ApiHelper.parseResponseBody(response);

						// Return Validation Errors
						return new ValidationError(errors);
				}
			}

			// TODO: Handle Errors
		}

		// Return Nothing
		return undefined;
	}
}
